<template>
  <div class="page-coupon">
    <section v-if="hasCoupon" class="coupon-list">
      <div class="tips">
        <template v-if="choseCouponUserId">
          您已选中优惠券1张，共
          <span style="color: #ff4e47">{{ couponAmount | price }}</span>
          可抵用
        </template>
        <template v-else>当前未使用优惠</template>
      </div>
      <van-radio-group v-if="canUseList && canUseList.length > 0" v-model="choseCouponUserId" @change="changeCoupon">
        <coupon-item
          type="choose"
          showNewIcon
          v-for="coupon in canUseList"
          :key="coupon.couponUserId"
          :item="coupon"
          @radioClick="radioClick"
        />
      </van-radio-group>

      <div v-if="cantUseList && cantUseList.length > 0" v-for="(item, key) in cantUseList" :key="key">
        <p v-if="item.needAddAmount" class="cant-use-reason">
          结算商品仅差{{ item.needAddAmount | intPrice }}元就可使用以下优惠券
        </p>
        <p v-if="item.needWaitDate" class="cant-use-reason">
          {{ item.needWaitDate | parseDate('yyyy年MM月dd日') }}后可使用以下优惠券
        </p>
        <coupon-item v-for="coupon in item.couponItemInfoList" cantUse :key="coupon.couponUserId" :item="coupon" />
      </div>
    </section>
    <van-empty
      v-if="!hasCoupon && !isLoading && !isError"
      class="flex-1"
      :image="require('@/assets/imgs/list-empty.png')"
      description="无可用优惠券"
    />
    <!-- 错误状态 -->
    <van-empty v-if="!isLoading && isError" :image="require('@/assets/imgs/list-empty.png')" class="flex-1">
      <template #description>
        <span>数据异常，请点击重试</span>
      </template>
      <van-button style="width: 112px" round size="middle" type="primary" @click="refreshPage">重试</van-button>
    </van-empty>
    <div v-if="hasCoupon && !isLoading && !isError" class="van-hairline--top">
      <div class="footer-btn" style="padding: 18px 28px">
        <div class="label">不使用优惠券</div>

        <van-radio v-model="checkRadio" name="1" @click.native="handleRadioClick"></van-radio>
      </div>
      <footer class="footer-btn" style="padding-top: 0">
        <van-button type="primary" size="mini" class="submit_button" round block v-reClick="onSelect">确定</van-button>
        <!-- <div>
        <span class="font12">可减：</span>
        <span class="can-reduce">
          <span>¥</span>
          <span class="money">{{ couponAmount | price }}</span>
        </span>
      </div>
      <div>
        <van-button
          style="width: 128px"
          :disabled="canUseList.length === 0 || fetchCouponLoading"
          size="middle"
          v-reClick="onSelect"
          round
          block
          type="primary"
        >
          立即使用
        </van-button>
      </div> -->
      </footer>
    </div>
  </div>
</template>
<script>
import CouponItem from './components/couponItem.vue';
import { mapState } from 'vuex';

export default {
  filters: {
    intPrice(val) {
      if (!val) return val;
      return Number(val) / 100;
    }
  },
  components: {
    CouponItem
  },
  data() {
    return {
      choseCouponUserId: null,

      checkRadio: '0',

      couponTemp: {},
      itemList: [],
      couponList: [],

      couponAmount: 0,

      statusMap: {
        canUse: 1,
        cantUse: 0
      },
      canUseList: [],
      fetchCouponLoading: false,
      isLoading: true,
      isError: false
    };
  },

  computed: {
    ...mapState('order', ['couponInfo', 'couponOptimalItemRequests']),

    cantUseList() {
      return this.couponList.filter((ele) => ele.type === this.statusMap.cantUse);
    },
    hasCoupon() {
      return this.cantUseList.length > 0 || this.canUseList.length > 0;
    }
  },
  created() {
    if (this.couponInfo.couponUserId) {
      this.couponTemp = this.couponInfo;
      this.couponAmount = this.couponInfo.discountsAmount;
      this.choseCouponUserId = this.couponInfo.couponUserId;
    }

    this.itemList = this.couponOptimalItemRequests;

    this.getCouponList();
  },
  methods: {
    getCouponList() {
      const { bizType, bizId, addressId } = this.$route.query;
      this.isError = false;
      this.isLoading = true;
      this.$fetch
        .getCanUseCouponList({ bizType, bizId, addressId, couponItemList: this.itemList })
        .then((res) => {
          const { couponGroupInfoVOList } = res;
          this.couponList = couponGroupInfoVOList;

          // 将选中的挪至第一个
          const arr = this.couponList.filter((ele) => ele.type === this.statusMap.canUse);
          const itemList = arr[0]?.couponItemInfoList || [];

          let chooseIndex = null;
          let chooseItem = null;
          if (this.choseCouponUserId) {
            chooseItem = itemList.find((ele, index) => {
              if (ele.couponUserId === this.choseCouponUserId) chooseIndex = index;
              return ele.couponUserId === this.choseCouponUserId;
            });
            if ((chooseIndex || chooseIndex === 0) && chooseItem) {
              itemList.splice(chooseIndex, 1);
              itemList.unshift(chooseItem);
            } else {
              this.$store.commit('order/setCouponInfo', {});
              this.choseCouponUserId = null;
              this.clearCouponInfo();
            }
          }
          this.canUseList = itemList;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.isError = true;
        });
    },
    changeCoupon(couponUserId) {
      if (!couponUserId) {
        this.clearCouponInfo();
        return;
      }
      if (couponUserId === this.choseCouponUserId) {
      
        const res = this.canUseList.filter(item => item.couponUserId === couponUserId)[0]
        if (res) {
          window.setTimeout(()=> {
             this.couponTemp = res;
           this.couponAmount = res.discountsAmount || 0;
          }, 0)
          
        }
       
        return
      }
      // this.fetchCouponLoading = true;
      // this.$fetch
      //   .confirmUseCoupon({ couponUserId, couponOptimalItemRequests: this.itemList })
      //   .then((res) => {
      //     // if (!res) {
      //     //   this.$toast('该优惠券不可用');
      //     //   this.choseCouponUserId = null;
      //     //   this.fetchCouponLoading = false;
      //     //   return;
      //     // }

      //     if (couponUserId === this.choseCouponUserId) {
      //       this.couponTemp = res;
      //       this.couponAmount = res.discountsAmount;
      //     }
      //     this.fetchCouponLoading = false;
      //   })
      //   .catch(() => {
      //     if (couponUserId === this.choseCouponUserId) this.choseCouponUserId = null;
      //     this.fetchCouponLoading = false;
      //   });
    },
    async onSelect() {
      if (this.couponTemp.couponUserId) {
        this.$store.commit('order/setHasMoreCoupons', true);
        this.$store.commit('order/setCouponInfo', this.couponTemp);
      } else {
        this.$store.commit('order/setCouponInfo', {});
      }
      this.$router.go(-1);
    },
    radioClick(item) {
      if (item.couponUserId === this.couponTemp.couponUserId) {
        this.$set(this, 'checkRadio', '1');
        this.choseCouponUserId = null;
        this.clearCouponInfo();
      } else {
        this.$set(this, 'checkRadio', '0');
      }
    },
    handleRadioClick() {
      if (this.checkRadio === '1') {
        this.choseCouponUserId = null;
        this.clearCouponInfo();
      }
    },
    clearCouponInfo() {
      this.couponTemp = {};
      this.couponAmount = 0;
    },
    refreshPage() {
      this.getCouponList();
    }
  }
};
</script>
<style lang="less" scoped>
.page-coupon {
  .tips {
    background: #fff;
    padding: 12px 0;
    font-size: 14px;
    color: #262626;
  }
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
  .flex-1 {
    flex: 1;
  }
  .coupon-list {
    padding: 12px 16px;
    background-color: #fff;
    height: 100%;
    overflow: auto;
    flex: 1;
    .cant-use-reason {
      color: #8c8c8c;
      font-size: 14px;
      margin-bottom: 12px;
    }
  }
  .footer-btn {
    width: 100%;
    display: inline-flex;
    background: #fff;
    align-items: center;
    padding: 8px 16px;
    justify-content: space-between;
    .label {
      color: #262626;
      font-size: 16px;
    }
  }
  .can-reduce {
    font-weight: 500;
    color: #ff4e47;
    font-size: 12px;
    .money {
      font-size: 16px;
    }
  }

  .font12 {
    color: #262626;
    font-size: 12px;
  }
  .submit_button {
    height: 40px;
    font-size: 16px;
    // color: #1e8dff;

    // width: 132px;
    color: #ffffff;
  }
}
</style>
